import React from "react";
import { Buildings, Briefcase } from "iconsax-reactjs";

export const data = (role: string | null) => ([
    {
        title: "Ma Société",
        url: "#",
        icon: <Buildings size={24} />,
        isActive: true,
        hidden: role === "CO",
        items: [
            {
                title: "Staffing",
                url: "staffing",
                hidden: role !== "PA" && role !== "MA",
            },
            {
                title: "Sous/Co-traitants",
                url: "/my-organization/contractors",
                hidden: role === "MA",
            },
            {
                title: "Clients",
                url: "/my-organization/customers",
                hidden: role === "MA",
            },
            {
                title: "Paramètres",
                url: "/my-organization/parameters",
                hidden: role === "OM" || role === "MA",
            },
        ],
    },
    {
        title: "Tableau de bord",
        url: "#",
        icon: <Briefcase size={24} />,
        items: [
            {
                title: "Dirigeant",
                url: "/dashboard/admin",
                hidden: role !== "PA"
            },
            {
                title: "Consultant",
                url: "/dashboard/consultant",
                hidden: false
            },
            {
                title: "DAS",
                url: "/dashboard/das",
                hidden: role !== "PA" && role !== "MA"
            },
            {
                title: "Office Manager",
                url: "/dashboard/office-manager",
                hidden: role !== "PA" && role !== "OM"
            },
            {
                title: "CODEV",
                url: "/dashboard/codev",
                hidden: role !== "PA" && role !== "MA"
            }
        ],
    },
]);